import React from 'react'

import {
  ButtonProps,
  Button as ImportedButton,
  Spinner,
} from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

const Container = styled.div<{ backgroundColor?: string }>`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  ${(props) => props.backgroundColor && `background: ${props.backgroundColor};`}
  &:last-child {
    margin-top: 10px;
  }
`

const StyledButton = styled(ImportedButton)`
  ${(props) =>
    props.tertiary &&
    `
    border: 1px solid ${style((theme) => theme.colors.red)};
    border-radius: 100px;`}
  ${(props) =>
    props.tertiary &&
    props.styleType === 'wire' &&
    `
  color: ${style((theme) => theme.colors.red)};
  &:disabled {
    background: none;
    color: ${style((theme) => theme.colors.stoneLight)};
    border: 1px solid ${style((theme) => theme.colors.stoneLight)};
    }
  `}

  width: 220px;
  margin: 0 auto;

  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    width: 100%;
  }
`

export type IButtonProps = {
  text: string
  isLoading?: boolean
  containerClassName?: string
  backgroundColor?: string
} & ButtonProps

export const MobileButton = ({
  text,
  isLoading,
  containerClassName,
  backgroundColor,
  ...props
}: IButtonProps) => (
  <Container className={containerClassName} backgroundColor={backgroundColor}>
    <StyledButton {...props}>
      {isLoading ? <Spinner height={20} width={20} /> : text}
    </StyledButton>
  </Container>
)
